import {
  OrganisationInputType,
  SupportedLocalesEnum
} from '../../graphql/private/PrivateSchemaTypes'
import { AccountPageForms, AccountPageFormTypes } from './accountPageTypes'
import { isEqual } from 'lodash'
import { OrganisationDetailFragment } from './AccountPage.codegen'

export const gqlInputVariableFromForms = (
  forms: AccountPageForms
): OrganisationInputType => {
  const notifications = forms[AccountPageFormTypes.Notifications].notifications

  return {
    email_comments: forms[AccountPageFormTypes.Notifications].email_comments,
    email_content: forms[AccountPageFormTypes.Notifications].email_content,
    allow_signup: forms[AccountPageFormTypes.Authentication].allowSignup,
    session_expiry: forms[AccountPageFormTypes.Authentication].sessionExpiry,
    ip_whitelist: forms[AccountPageFormTypes.Authentication].ipWhitelist,
    domain_lock: forms[AccountPageFormTypes.Authentication].domainLock,
    oauthConfigs: forms[AccountPageFormTypes.Authentication].oauthConfigs,
    name: forms[AccountPageFormTypes.Customise].name,
    styles: forms[AccountPageFormTypes.Customise].styles,
    default_user_locale:
      forms[AccountPageFormTypes.Customise].default_user_locale,
    timezone: forms[AccountPageFormTypes.Customise].timezone,
    subdomain: forms[AccountPageFormTypes.Customise].subdomain,
    can_students_update_profile:
      forms[AccountPageFormTypes.Customise].can_students_update_profile,
    hotjar_site_id: forms[AccountPageFormTypes.Customise].hotjar_site_id,
    cpd_switched_on: forms[AccountPageFormTypes.Customise].cpd_switched_on,
    link_unfurling_switched_on:
      forms[AccountPageFormTypes.Customise].link_unfurling_switched_on,
    notifications: {
      slack: {
        organisation_access_token:
          notifications?.slack?.organisation_access_token,
        slack_access_token: notifications?.slack?.slack_access_token
      },
      sms: notifications?.sms,
      msteams: notifications?.msteams
    },
    embed_domains: forms[AccountPageFormTypes.Customise].embed_domains
  }
}

export const dirtyVariableProps = (
  pristine: OrganisationInputType,
  current: OrganisationInputType
): OrganisationInputType => {
  const vars: OrganisationInputType = {}

  Object.keys(pristine).forEach((prop) => {
    if (!isEqual(pristine[prop], current[prop])) {
      vars[prop] = current[prop]
    }
  })

  return vars
}

const parseWhitelist = (whitelistText: string[]) =>
  whitelistText.map((domain) => domain.trim()).filter((domain) => !!domain)

export const createAccountPageForm = (
  organisation: OrganisationDetailFragment
): AccountPageForms => {
  return {
    [AccountPageFormTypes.Customise]: {
      timezone: organisation.timezone,
      default_user_locale:
        organisation.default_user_locale as SupportedLocalesEnum,
      // @ts-expect-error 9/11/2020
      name: organisation.name,
      subdomain: organisation.subdomain?.name
        ? organisation.subdomain.name
        : '',
      // @ts-expect-error 9/11/2020
      color: organisation.color,
      styles: organisation.styles,
      // @ts-expect-error 9/11/2020
      logo: organisation.logo,
      // @ts-expect-error 9/11/2020
      can_students_update_profile: organisation.can_students_update_profile,
      // @ts-expect-error 9/11/2020
      hotjar_site_id: organisation.features?.hotjar?.site_id,
      // @ts-expect-error 9/11/2020
      hotjar_enabled: organisation.features?.hotjar?.enabled,
      // @ts-expect-error 9/11/2020
      link_unfurling_switched_on:
        organisation.features?.link_unfurling?.switched_on,
      // @ts-expect-error 9/11/2020
      cpd_switched_on: organisation.features?.cpd?.switched_on,
      embed_domains: organisation.embed_domains
        ? organisation.embed_domains
        : { enabled: false, domains: [] }
    },
    [AccountPageFormTypes.Authentication]: {
      domainLock: organisation.domain_lock
        ? parseWhitelist(organisation.domain_lock)
        : null,
      // @ts-expect-error 9/11/2020
      sessionExpiry: organisation.session_expiry,
      // @ts-expect-error 9/11/2020
      allowSignup: organisation.allow_signup,
      ipWhitelist: organisation.ip_whitelist,
      domainWhitelistBreaches: organisation.domainWhitelistBreaches,
      oauthConfigs: organisation.oauthConfigs
        ?.filter((oauthConfig) => oauthConfig.enabled)
        .map((oauthConfig) => oauthConfig.provider)
    },
    [AccountPageFormTypes.Notifications]: {
      email_comments: organisation.email_comments,
      email_content: organisation.email_content,
      notifications: organisation.notifications
    }
  }
}

export const accountPageDefaultFromState: AccountPageForms = {} as any

Object.keys(AccountPageFormTypes).forEach((formName) => {
  accountPageDefaultFromState[AccountPageFormTypes[formName]] = {}
})
